module.exports = __webpack_public_path__ + "img/ass33.d8a69438.png";